<div *ngIf="!(isLoading$ | async) && !initialLoading">
  <cml-panel-buttons [buttons]="buttons"></cml-panel-buttons>
  <div class="form-container">
    <form [formGroup]="form" class="form">
      <div class="header">
        <div class="column"><p>Nastavení účetní jednotky: </p></div>
        <div class="column">{{ getFullName() }}</div>
      </div>
      <ng-template ngFor let-field [ngForOf]="fields">
        <div class="content">
          <div class="column">{{ field.name }}</div>
          <div class="column">
            <mat-checkbox [formControlName]="field.name"></mat-checkbox>
          </div>
          <cml-autocomplete-control *ngIf="field.type === 'autocomplete' && field.observable"
                                    [formControl]="$any(form.controls[field.name])" [field]="field"
                                    [errorMessage]="getErrorMessage(field.name)"></cml-autocomplete-control>
        </div>
      </ng-template>
    </form>
  </div>
</div>

<cml-extended-detail></cml-extended-detail>
